import AtPanel from './components/main'

export {
  AtPanel
}
export default {
  install(Vue) {
    Vue.component('at-panel', AtPanel)
  }
}



// WEBPACK FOOTER //
// ./src/packages/components/panel/index.js